(ns common.fields.schema
  (:require [clojure.string :as string]
            [common.fields.company-fields :as company-fields]
            [common.fields.deal-fields :as deal-fields]
            [potpuri.core :as potpuri]
            [schema.core :as s]))

(s/defschema FieldSetting
  {(s/optional-key :description)               s/Str
   (s/optional-key :disabled-by-tenant-admin?) s/Any
   (s/optional-key :disabled-by-sys-admin?)    s/Any
   (s/optional-key :user)                      s/Any
   (s/optional-key :disabled-in-web-entry?)    s/Keyword
   (s/optional-key :webentry-visibility)       s/Keyword
   (s/optional-key :external-guest)            s/Keyword
   (s/optional-key :internal-guest)            s/Keyword
   (s/optional-key :ui-modules)                s/Any
   (s/optional-key :hide-when-disabled)        s/Any})

(defonce default-field-settings
         (merge company-fields/schema
                deal-fields/schema))

(defn external-guest [external-guest-setting]
  (some #{external-guest-setting} [:disabled-not-used :not-used true]))

(defn hidden-by-tenant [tenant-setting]
  (some #{tenant-setting} [:disabled-not-used :not-used true]))

(defn hidden-by-sysadmin [sys-setting]
  (some #{sys-setting} [:disabled-not-used :not-used true]))

(defn hidden-from-external-guest [ext-setting]
  (or (nil? ext-setting)
      (some #{ext-setting} [:disabled-not-used :not-used true])))

(defn hidden-from-internal-guest [int-setting]
  (or (nil? int-setting)
      (some #{int-setting} [:disabled-not-used :not-used true])))

(defn visible-in-webentry [setting]
  (let [stng (some #{setting} [:webentry-field-visible :webentry-field-mandatory
                               :mandatory :in-use :disabled-in-use :disabled-mandatory])]
    stng))

(defn webentry-value [setting]
  (case setting
    :webentry-field-mandatory :mandatory
    :mandatory :mandatory
    :disabled-mandatory :mandatory
    :webentry-field-visible :in-use
    :in-use :in-use
    :disabled-in-use :in-use
    :webentry-field-hidden :not-used
    :not-used :not-used
    :disabled-not-used :not-used
    nil))

(defn mandatory-in-webentry [setting]
  (some #{setting} [:webentry-field-mandatory :mandatory :disabled-mandatory]))

(defn disabled-in-webentry [setting]
  (some #{setting} [:disabled-not-used :disabled-in-use :disabled-mandatory]))

(defn disabled-in-admin [setting]
  (some #{setting} [:disabled-not-used :disabled-in-use]))

(defn disabled-in-external [setting]
  (some #{setting} [:disabled-not-used :disabled-in-use]))

(defn disabled-in-internal [setting]
  (some #{setting} [:disabled-not-used :disabled-in-use]))

(defn webentry-settings [webentry-settings]
  (let [webentry-settings (or webentry-settings {})]        ;;if nil, deep-merge below would return {}
    (potpuri/deep-merge
      (->> default-field-settings
           (map (fn [[k v]]
                  [k (webentry-value (:webentry-visibility v))]))
           (into {}))
      webentry-settings
      (->> default-field-settings
           (map (fn [[k v]]
                  [k (webentry-value (:webentry-visibility v))]))
           (filter (fn [[k v]]
                     (some #{v} [:disabled-not-used :disabled-in-use :disabled-mandatory])))
           (into {})))))

(defn tenant-field-settings [tenant-field-settings]
  (potpuri/deep-merge
    default-field-settings                                  ;; base settings
    (or tenant-field-settings {})                           ;; overwrite with tenant settings
    (->> default-field-settings                             ;; overwrite disabled values
         (map (fn [[fld-key fld-settings]]
                (let [disabled-settings (->> fld-settings
                                             (filter (fn [[k v]]
                                                       (some #{v} [:disabled-not-used :disabled-in-use :disabled-mandatory])))
                                             (into {}))]
                  (when (seq disabled-settings)
                    [fld-key disabled-settings]))))
         (into {}))))

(defn field-description [field-settings field]
  (let [field-setting (get field-settings field)]
    (:description field-setting)))

(defn field-error? [field entity entity-errors]
  (let [errors (get entity-errors (:db/id entity))
        field-error (get errors (:attribute field))]
    field-error))

(defn webentry-keys [field-settings]
  (->> field-settings
       (filter (fn [f-s]
                 (let [k (key f-s)
                       v (val f-s)
                       webentry-visibility (:webentry-visibility v)
                       disabled (or (hidden-by-tenant (:disabled-by-tenant-admin? v))
                                    (hidden-by-sysadmin (:disabled-by-sys-admin? v)))]
                   (and (not disabled)
                        (visible-in-webentry webentry-visibility)))))
       keys))

(defn currency-symbols [field-keys]
  (remove nil? (map (fn [fld-key]
                      (let [key-ns (namespace fld-key)
                            key-name (name fld-key)]
                        (when (string/starts-with? key-name "cur-")
                          (keyword key-ns (str key-name "--sym")))))
                    field-keys)))
